export function enableReconnectOnTabResume() {
  window.addEventListener("phx:mailroom:enable-reconnect-on-tab-resume", () => {
    console.log("enable-reconnect-on-tab-resume: enabling reconnect on tab resume");
  
    document.addEventListener("resume", () => {
      console.log("enable-reconnect-on-tab-resume: resume detected");
  
      if (window.liveSocket) {
        console.log("enable-reconnect-on-tab-resume: disconnecting and reconnecting liveSocket");
        window.liveSocket.disconnect();
        window.liveSocket.connect();
      }
    });
  }, { once: true });
}